
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-media/news",
      function () {
        return require("private-next-pages/news-media/news/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-media/news"])
      });
    }
  